import {
  Accordion,
  Grid,
  Group,
  NumberInput,
  Stack,
  Text,
  ThemeIcon,
} from "@mantine/core";
import { DateTimePicker } from "@mantine/dates";
import {
  IconBolt,
  IconCalendarTime,
  IconClock,
  IconGauge,
} from "@tabler/icons-react";
import dayjs from "dayjs";
import { useState } from "react";
import { useLanguage } from "../../../stores/LanguageStore";
import { useCampaignStore } from "../../../stores/CampaignStore";
import ProgramCard from "./ProgramCard";

// --- COMPOSANT PRINCIPAL ---
const NewsletterProgram = () => {
  const lang = useLanguage((s) => s.language);
  const programData = useCampaignStore((s) => s.programData);
  const setProgramData = useCampaignStore((s) => s.setProgramData);

  const [editDate, setEditDate] = useState(false);
  const [editLimit, setEditLimit] = useState(false);

  const dailyLimit = programData?.daily_send_limit || 0;

  const updateData = (field, value) => {
    setProgramData({
      ...programData,
      [field]: value,
    });
    // setProgramData((prev) => ({ ...prev, [field]: value }));
  };

  return (
    <Accordion
      variant="contained"
      bg={"#fff"}
      radius={"xl"}
      // defaultValue={"list"}
      mt={"md"}
    >
      <Accordion.Item value="list">
        <Accordion.Control>
          <Group>
            <ThemeIcon
              variant="light"
              size={"xl"}
              radius={"xl"}
              color="primary"
            >
              <IconClock />
            </ThemeIcon>
            <Stack gap={0}>
              <Text fw={600}>{lang.newsletter.step_2_title}</Text>
              <Text c="dimmed" size="sm">
                {lang.newsletter.step_2_desc}
              </Text>
            </Stack>
          </Group>
        </Accordion.Control>

        <Accordion.Panel>
          <Grid gutter="md" mt="sm">
            {/* 1. DATE DU PREMIER ENVOI */}
            <Grid.Col span={{ base: 12, md: 6 }}>
              <ProgramCard
                icon={<IconBolt size={24} />}
                label={
                  lang.workflows?.program?.step_config?.date_start ||
                  "Date du premier envoi"
                }
                valueDisplay={dayjs(
                  programData?.date_start
                    ? new Date(programData.date_start)
                    : new Date(),
                ).format("DD MMM YYYY à HH:mm A")}
                bg="var(--mantine-color-primary-0)"
                isEditing={editDate}
                setIsEditing={setEditDate}
                editorComponent={
                  <DateTimePicker
                    onChange={(val) => {
                      updateData("date_start", val?.toISOString());
                    }}
                    value={
                      programData?.date_start
                        ? new Date(programData.date_start)
                        : new Date()
                    }
                    leftSection={<IconCalendarTime size={16} />}
                    valueFormat="DD MMM YYYY à HH:mm A"
                    size="sm"
                    radius="md"
                    w="100%"
                    autoFocus
                  />
                }
              />
            </Grid.Col>

            {/* 3. LIMITE QUOTIDIENNE */}
            <Grid.Col span={{ base: 12, md: 6 }}>
              <ProgramCard
                icon={<IconGauge size={24} />}
                label={
                  lang.workflows?.program?.step_config?.daily_send_limit ||
                  "Limite quotidienne d'envoi"
                }
                valueDisplay={dailyLimit}
                helpText={lang.campaign?.limit_help}
                isEditing={editLimit}
                setIsEditing={setEditLimit}
                editorComponent={
                  <NumberInput
                    value={dailyLimit}
                    onChange={(val) => updateData("daily_send_limit", val)}
                    min={0}
                    size="sm"
                    radius="md"
                    w="100%"
                    autoFocus
                  />
                }
              />
            </Grid.Col>
          </Grid>
        </Accordion.Panel>
      </Accordion.Item>
    </Accordion>
  );
};

export default NewsletterProgram;
